import { Record } from "immutable";

const SurveyResultRecord = Record({
  id: null,
  surveyId: null,
  localeId: null,
  loginDt: null,
  sendDt: null,
  freeComment1: "",
  freeComment2: "",
  q1: "",
  q2: "",
  q3: "",
  q4: "",
  q5: "",
  q6: "",
  q7: "",
  q8: "",
  q9: "",
  q10: "",
  q11: "",
  q12: "",
  q13: "",
  q14: "",
  q15: "",
  q16: "",
  q17: "",
  q18: "",
  q19: "",
  q20: "",
  q21: "",
  q22: "",
  q23: "",
  q24: "",
  q25: "",
  q26: "",
  q27: "",
  q28: "",
  q29: "",
  q30: "",
  q31: "",
  q32: "",
  q33: "",
  q34: "",
  q35: "",
  q36: "",
  q37: "",
  q38: "",
  q39: "",
  q40: "",
  q41: "",
  q42: "",
  q43: "",
  q44: "",
  q45: "",
  q46: "",
  q47: "",
  q48: "",
  q49: "",
  q50: "",
  q51: "",
  q52: "",
  q53: "",
  q54: "",
  q55: "",
  q56: "",
  q57: "",
  q58: "",
  q59: "",
  q60: "",
  q61: "",
  q62: "",
  q63: "",
  lockVersion: 0
});

class SurveyResult extends SurveyResultRecord {}

export default SurveyResult;



// WEBPACK FOOTER //
// ./src/models/SurveyResult.js